import {createContext, useState} from "react";


export const NotificacionesContext = createContext(null);

export const NotificacionesProvider = ({children}) => {
  const [totalNotificaciones, setTotalNotificaciones] = useState(0);

  const setNotificaciones = (notifications) => {
    setTotalNotificaciones(notifications);
  }

  return (
    <NotificacionesContext.Provider value={{
      totalNotificaciones,
      setNotificaciones,
    }}>
      {children}
    </NotificacionesContext.Provider>
  );
}
